import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import merchantColumns from "./merchantColumns";

type Props = {
  name: string;
  search: string;
  tags: string[];
};

const query = gql`
  query Currentlist(
    $search: String
    $tags: [String]
    $offset: Int
    $limit: Int
  ) {
    merchants(search: $search, tags: $tags, offset: $offset, limit: $limit) {
      id
      name
      tags
      created_at
      snapmin_url
      email
      contact_people {
        name
        phone
        email
      }
      store_infos {
        address
        address2
        address3
        city
        area_code
        store_area {
          name
        }
        store_province {
          name
        }
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ search, tags, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      search,
      tags,
      offset,
      limit
    }
  })
});

export default withPagination(
  withData(props => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={merchantColumns}
        defaultColumns={["Date", "Name", "Tags", "Email"]}
        rows={props.data.merchants || []}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
